module.exports = __webpack_public_path__ + "static/media/28DGC11.c782ab8f.jpg";